import React from "react";

const Select = ({
  labelName = "Label Name",
  selectLabel = "Option",
  selectClass = "",
  name = "",
  selectedValue = "",
  handleSelect = function o() { },
  optionValue = null,
  optionName = "name",
  array = [],
  mandatory = true,
  moduleName = "",
  labelClass = "",
  disabled = false,
  accsessablityId = ""
}) => {
  return (
    <>
      <label id={accsessablityId} className={`form-label labelText ${labelClass}`}>{labelName}</label>{" "}
      {mandatory && <span className="text-red">*</span>}
      <div className="custom-select">
        <select
          className={`form-select inputText  ${selectClass}`}
          id={`select-${name}`}
          name={name}
          disabled={disabled}
          value={selectedValue}
          onChange={(e) => handleSelect(e)}
        >
          <option selected value={moduleName == "Pmhospital" ? "" : 0}>{selectLabel}</option>
          {array?.length > 0 &&
            array?.sort((a, b) => a[`${optionName}`]?.localeCompare(b[`${optionName}`]))?.map((item, index) => (
              <option key={index}  className={selectedValue === item[`${optionValue}`] ? "text-red" : ""} value={moduleName == "Pmhospital" ? item[`${optionName}`] : item[`${optionValue}`]}>
                {item[`${optionName}`]}
              </option>
            ))}
        </select>
      </div>
    </>
  );
};

export default Select;
